import Modal from './modal';

class ModalDefault {
	constructor(el) {
		this.el = el;
		this.modalContent = this.el.querySelector('.js__modal--default-content').innerHTML;
		this.initializeModals();
	}

	initializeModals = () => {
		this.el.addEventListener('click', () => {
			Modal.show(this.modalContent);
		});
	};
}

export default ModalDefault;
